import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  TableHeader,
  TableCellDefault,
  Loading,
  ModalDeleteConfirm,
  TableAction,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  deleteServiceTutupTagihanById,
  getByServiceTutupTagihan,
  headCellsService,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  tipePembayaranName,
} from "App/utils/helpers";
import FormFilterServiceTutupTagihan from "./FormFilterServiceTutupTagihan";

export default function TableListServiceTutupTagihan() {
  const classes = STYLE_DEFAULT_MASTER();

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [serviceTutupTagihanID, setServiceTutupTagihanID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByServiceTutupTagihan(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function clickDelete(row) {
    setServiceTutupTagihanID(row.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function deleteList() {
    const res = await deleteServiceTutupTagihanById(serviceTutupTagihanID);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <div className={classes.root}>
        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterServiceTutupTagihan
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <div className='mt-1'>
            <TableDaftarInventoryControl
              rows={rows}
              classes={classes}
              clickDelete={clickDelete}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </>
  );
}

export const TableDaftarInventoryControl = ({ rows, classes, clickDelete }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  return (
    <TableContainer className='custom-scrollbar'>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCellsService}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    isUpdate={false}
                  />
                </TableCell>
                <TableCell align='left'>{row.id}</TableCell>
                <TableCell align='left'>
                  {tipePembayaranName(row.tipe_pembayaran_id)}
                </TableCell>
                <TableCell align='left'>{row.kas_name}</TableCell>
                <TableCell align='left'>{row.keterangan}</TableCell>

                <TableCellDefault row={row} type='custom' />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCellsService.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
